<div class="component">

    <div class="content d-flex flex-column justify-content-between">
        <div class="d-flex flex-column">
            <div class="raceInfo d-flex flex-row justify-content-around">
                @if(race.distance) {
                <div class="info d-flex flex-column align-items-center justify-content-center">
                    <img src="../../../assets/icons/distance.svg" alt="Distance" class="icon" draggable="false">
                    <h3>{{race.distance / 1000}}KM</h3>
                </div> }

                @if(race.distance) {
                <div class="info d-flex flex-column align-items-center justify-content-center">
                    <img src="../../../assets/icons/rise.svg" alt="Distance" class="icon" draggable="false">
                    <h3>{{race.elevation}}m D+</h3>
                </div>
                }


            </div>

            @if (race.description) {
            <div class="description">
                <!-- <h5>Quelques mots sur la course</h5> -->
                <div [innerHTML]="race.description"></div>
            </div>
            }
        </div>

        @if (hasLiveVideo) {
        <div class="live-video">
            <iframe [src]="urlLiveVideo" title="live video" width="100%" height="100%"
                style="border:none;overflow:hidden" allowfullscreen="true"
                allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                allowFullScreen="true"></iframe>
            <!-- Votre vidéo en direct de la finish line -->
        </div>
        }


        <!-- <div *ngIf="registrationUrl" class="registration-button d-flex justify-content-center mb-2 mt-2">
            <button type="button" class="btn btn-primary">
                <a [href]="registrationUrl" target="_blank" style="text-decoration: none; color: white;">S'inscrire</a>
            </button>
        </div> -->

        <!-- <iframe  src="https://www.youtube.com/embed/36YnV9STBqc" title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; muted"
            allowfullscreen></iframe> -->
    </div>

</div>